export default "* Hulemaleri\n* Forhistorisk\n* Fortælling\n";